import { Module, Store } from 'vuex';
import { default as _Vue } from 'vue';
import consola, { Consola } from 'consola';
import { get } from 'lodash';

export abstract class AbstractService<TOptions, TState> {
  protected Vue!: typeof _Vue;
  protected store!: Store<any>;
  protected logger: Consola;
  protected options: TOptions;

  public serviceName: string;

  private _defaultState!: any;

  protected constructor(options: TOptions = {} as TOptions, serviceName: string) {
    this.options = options;
    this.serviceName = serviceName;

    this.logger = consola.withTag(serviceName);
  }

  async init(Vue: typeof _Vue, store: Store<any>): Promise<void> {
    this.Vue = Vue;
    this.store = store;

    this.printNameInConsole();
  }

  public printNameInConsole() {
    this.logger.log('📦 Loaded as standard service');
  }

  protected get _rootPath() {
    return this.strPath.split('/').join('.');
  }

  protected get strPath() {
    return `pdc/${this.serviceName}`;
  }

  protected $register(defaultState: TState, mdl: Module<TState, any>) {
    this.store.registerModule(this.strPath.split('/'), {
      namespaced: true,
      state: defaultState,
      ...mdl,
    });
  }

  protected $state<E>(key: string): E {
    return get(this.store.state, `${this._rootPath}.${key}`);
  }

  protected $commit(key: string, value?: any) {
    return this.store.commit(`${this.strPath}/${key}`, value);
  }

  protected $dispatch(key: string, ...options: any) {
    return this.store.dispatch(`${this.strPath}/${key}`, ...options);
  }

  protected $getters(key: string, ...options: any) {
    return this.store.getters[`${this.strPath}/${key}`](options);
  }

  public $clean() {
    const _state = get(this.store.state, `${this._rootPath}`);

    this.logger.info('CLEANUP');

    Object.keys(this.defaultState).forEach((key) => {
      _state[key] = this.defaultState[key as keyof TState];
      // this.logger.log('RESET', this._rootPath, key, this.defaultState[key]);
    });
  }

  // ---------------------------------------------------------------------------

  public get defaultState(): TState {
    return this._defaultState;
  }
  public set defaultState(value: TState) {
    this._defaultState = value;
  }
}
